/* eslint-disable react/jsx-props-no-spreading */
// import { useMemo } from 'react';
/* eslint-disable */
import { Col, Row, Form, Select, Input, Button, Divider, DatePicker, Tooltip } from 'antd';
import { DeleteOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { USUARIOS_FISCALIZACION } from 'constants/nombresCatalogos';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Upload, Accordion, AddButton } from 'components';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';
import './Verificadores.scss';
import '../../../../Formulario.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { useState, useEffect } from 'react';

const Verificadores = ({ form, isLoadingImages }) => {
  // console.log(form, 'form verificadores');
  const placement = 'topRight';
  const catVerificadores = useSelector(selectCatalogByName(USUARIOS_FISCALIZACION));

  const { verificadores } = form.getFieldsValue(['verificadores']);
  const [verificadoresForm, setVerificadoresForm] = useState(
    verificadores?.length > 0 ? verificadores : []
  );
  const [verificaManual, setVerificaManual] = useState({ activo: false, id: -1 });

  const addVerificadorPorCatalogo = (_, key) => {
    setVerificaManual({ activo: false, id: key });
    const updatedVerificador = {
      ...verificadoresForm[key],
      idFirmante:
        verificadoresForm[key].idFirmante &&
        verificadoresForm[key].idFirmante != null &&
        verificadoresForm[key].idFirmante > 0
          ? verificadoresForm[key].idFirmante
          : null,
      nombre: null,
      apMaterno: null,
      apPaterno: null,
      puesto: null
    };
    const updatedVerificadoresList = [...verificadores];
    verificadores[key] = updatedVerificador;
    updatedVerificadoresList[key] = updatedVerificador;
    setVerificadoresForm(updatedVerificadoresList);
  };

  const addVerificadorManual = (_, key) => {
    setVerificaManual({ activo: true, id: key });
    const updatedVerificador = {
      ...verificadoresForm[key],
      idFirmante:
        verificadoresForm[key].idFirmante &&
        verificadoresForm[key].idFirmante != null &&
        verificadoresForm[key].idFirmante > 0
          ? verificadoresForm[key].idFirmante
          : 0,
      nombre: null,
      apMaterno: null,
      apPaterno: null,
      puesto: null,
      catVerificador: undefined
    };
    const updatedVerificadoresList = [...verificadores];
    verificadores[key] = updatedVerificador;
    updatedVerificadoresList[key] = updatedVerificador;
    setVerificadoresForm(updatedVerificadoresList);
  };

  useEffect(() => {
    setVerificadoresForm(verificadores);
  }, [verificadores]);

  const formComponent = ({ key, remove, name, disabled, isLastHallazgo, ...restField }) => (
    <div>
      {
        // console.log('propiedades form', key, name)
      }
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={13} className="formulario-hallazgos-tabla-header">
            Información del verificador:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Identificación anverso:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Identificación reverso:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Firma digital:
          </Col>
          <Col xs={2} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>
        <Row>
          <Col xs={13} className="hallazgos-detalle">
            {verificaManual.activo && verificaManual.id === name ? (
              <>
                <Row gutter={[7, 0]} className="row-formulario-nested">
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      className=""
                      name={[name, 'nombre']}
                      label="Nombre (s):"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input placeholder="Nombre" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={2} className="col-add-verificador">
                    <Tooltip title="Agrega verificador mediante seleccionador">
                      <Button
                        className="add-verificadorManual"
                        shape="square"
                        icon={<MinusOutlined className="plus-icon" />}
                        onClick={(e) => addVerificadorPorCatalogo(e, name)}
                      />
                    </Tooltip>
                  </Col>
                </Row>
                <Row gutter={[7, 0]} className="row-formulario-nested">
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      className=""
                      name={[name, 'apPaterno']}
                      label="Primer apellido:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input placeholder="Primer apellido" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      className=""
                      name={[name, 'apMaterno']}
                      label="Segundo apellido:">
                      <Input placeholder="Segundo apellido" />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ) : (
              <Row gutter={[7, 0]} className="row-formulario-nested">
                {/* Son los monitoristas */}
                <Col span={12}>
                  <Form.Item
                    className=""
                    name={[name, 'catVerificador']}
                    label="Nombre del verificador:"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    <Select
                      placeholder="Selecciona..."
                      style={{ width: '100%' }}
                      allowClear
                      options={catVerificadores}
                      fieldNames={{
                        label: 'nombreCompletoPuesto',
                        value: 'idUsuario'
                      }}
                      filterOption={(inputValue, option) =>
                        option.nombreCompletoPuesto
                          ?.toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={2} className="col-add-verificador">
                  <Tooltip title="Agrega verificador manualmente">
                    <Button
                      className="add-verificadorManual"
                      shape="square"
                      icon={<PlusOutlined className="plus-icon" />}
                      onClick={(e) => addVerificadorManual(e, name)}
                    />
                  </Tooltip>
                </Col>
              </Row>
            )}
            <Row gutter={[7, 0]} className="row-formulario-nested">
              {verificadoresForm &&
                verificadoresForm[key] &&
                verificadoresForm[key]?.idFirmante !== null &&
                (verificadoresForm[key]?.idFirmante === 0 ||
                  verificadores[key]?.idFirmante > 0) && (
                <Col span={12}>
                  <Form.Item
                    {...restField}
                    className=""
                    name={[name, 'puesto']}
                    label="Puesto:"
                    rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                    <Input placeholder="Escribe..." />
                  </Form.Item>
                </Col>
              )}
              <Col span={12}>
                <Form.Item
                  {...restField}
                  className=""
                  name={[name, 'oficioComision']}
                  label="Oficio de comisión:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'fechaInicioComision']}
                  label="Emisión de oficio de comisión:"
                  rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
                  <DatePicker
                    style={{ width: '100%' }}
                    placeholder="Selecciona..."
                    format={DATE_FORMAT_FILTER_COLUMN}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'fechaFinComision']}
                  label="Vigencia de comisión:"
                  rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
                  <DatePicker
                    style={{ width: '100%' }}
                    placement={placement}
                    placeholder="Selecciona..."
                    format={DATE_FORMAT_FILTER_COLUMN}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'idAnverso']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'idReverso']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'firma']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={2}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastHallazgo} style={{ height: '2em' }}>
                <DeleteOutlined
                  onClick={() => {
                    if (verificadores[name] !== undefined) {
                      verificadores[name].estatus = 0; // MNI - Actualiza el estatus de 1 a 0 para ocultarlo de la vista sin eliminarlo de la lista
                      form.setFieldsValue({ verificadores });
                    } else if (verificadores[name] === undefined) {
                      remove(name);
                    }
                  }}
                />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <span className="seccion-hallazgos-titulo">Agrega los registros necesarios.</span>
      <Form layout="vertical" form={form}>
        <Form.List name="verificadores" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {(() => {
                  const filteredFields = fields.filter(
                    ({ name }) => form.getFieldValue(['verificadores', name, 'estatus']) !== 0 // Validación para mostrar o no mostrar el Testigo por su estatus, solo mostrará los activos estatus 1
                  );
                  return filteredFields.map(({ key, name, ...restField }) => {
                    const isLastHallazgo = filteredFields.length <= 1; // Bloquea el icono de eliminación si es el último testigo a eliminar

                    const verificador = {
                      key: `verificador_${key}`,
                      label: `verificador ${name + 1}`,
                      forceRender: true,
                      children: formComponent({
                        remove,
                        name,
                        isLastHallazgo,
                        ...restField
                      })
                    };

                    return (
                      <Accordion
                        key={key}
                        items={[verificador]}
                        defaultActiveKey={['verificador_0']}
                      />
                    );
                  });
                })()}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

Verificadores.propTypes = {
  form: PropTypes.shape({
    getFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func,
    setFieldsValue: PropTypes.func
  }).isRequired,
  isLoadingImages: PropTypes.bool.isRequired
};

export default Verificadores;
